import type { ReactNode } from 'react';
import { Card } from '@zenid/web';
import { css } from '../../../../styled-system/css';

export function TermsCard({ children }: { children: ReactNode }) {
  return (
    <Card
      className={css({
        width: '100%',
        backgroundColor: '{colors.background.white}',
        flexDirection: 'column',
        padding: '{spacing.40} {spacing.16} {spacing.32}',
        gap: '{spacing.32}',
        textStyle: 'body.m.default',
        '& > ol li': {
          listStyleType: 'none',
        },
        // リストの2階層目に対してインデント与える
        '& > ol, ul': {
          display: 'flex',
          flexDirection: 'column',
          gap: '{spacing.8}',
          paddingLeft: 0,
          '& > li': {
            textIndent: '-24px',
            paddingLeft: '{spacing.24}',
          },
          // リストの3階層目に対してインデント与える
          '& > ol, ul': {
            paddingLeft: '{spacing.24}',
            '& > li': {
              textIndent: '-24px',
              paddingLeft: '{spacing.24}',
            },
            // リストの4階層目に対してインデント与える
            '& > ol, ul': {
              paddingLeft: '{spacing.24}',
              '& > li': {
                textIndent: '-24px',
                paddingLeft: '{spacing.24}',
              },
            },
          },
        },
        sm: {
          gap: '{spacing.48}',
          padding: '{spacing.48} {spacing.32} {spacing.32}',
        },
      })}
    >
      {children}
    </Card>
  );
}
